import { render } from "./Photography.vue?vue&type=template&id=2d8fe9a7&scoped=true"
import script from "./Photography.vue?vue&type=script&lang=js"
export * from "./Photography.vue?vue&type=script&lang=js"

import "./Photography.vue?vue&type=style&index=0&id=2d8fe9a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8fe9a7"]])

export default __exports__